import { render, staticRenderFns } from "./ConsultingServices.vue?vue&type=template&id=62697a93&scoped=true&"
import script from "./ConsultingServices.vue?vue&type=script&lang=js&"
export * from "./ConsultingServices.vue?vue&type=script&lang=js&"
import style0 from "./ConsultingServices.vue?vue&type=style&index=0&id=62697a93&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62697a93",
  null
  
)

export default component.exports